import {IPNSSearch} from '@portal-ng/PNSModels/PNSSearch.model';

export interface IPNSProviderSearch extends IPNSSearch {
  locationId: string | null;
  firstName?: string;
  lastName?: string;
}
